import React from 'react';
import { JsonView, allExpanded, darkStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import styles from './json-viewer.module.sass';

export function JSONViewer({
  data,
  shouldExpandNode = allExpanded,
  style = darkStyles,
  containerClassName = 'sp-background',
}) {
  style.container = styles[containerClassName];
  return (
    <JsonView data={data} shouldExpandNode={shouldExpandNode} style={style} />
  );
}
